import Rest from '@/services/Rest'

export default class ModelService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/models'

  /**
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  make(data) {
    return this.post(`/make`, data, {headers: {'content-type': 'application/xml'}, responseType: 'arraybuffer'})
  }

  fetchByCode(code) {
    return this.get(`/code/${code}`)
  }

  simulationsByModelCode(code) {
    return this.get(`/code/${code}/simulations`)
  }

  simulation(id) {
    return this.get(`/simulations/${id}`)
  }

  simulations(parameters){
    return this.get(`/simulations`, {
      params: parameters
    })
  }

}
